import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { FaBars } from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Header.css";

const sections = ["gioi-thieu", "tuyen-dung"];

const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    setExpanded(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const section = document.getElementById(id);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    } else {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      let current = "";
      sections.forEach((id) => {
        const section = document.getElementById(id);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            current = id;
          }
        }
      });
      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // check ngay khi load
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="header">
      <Navbar
        expanded={expanded}
        expand="lg"
        bg="light"
        variant="light"
        fixed="top"
        className="header__navbar"
      >
        <Container>
          <Navbar.Brand
            as={Link}
            to="/"
            className="header__logo"
          >
            <img
              src="/logo-design24.webp"
              alt="Học viện Design24"
              className="header__logo-img"
            />
            <span className="header__logo-text">Học viện Design24</span>
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="header-navbar-nav"
            onClick={() => setExpanded(expanded ? false : "expanded")}
            className="header__toggle"
          >
            <FaBars />
          </Navbar.Toggle>
          <Navbar.Collapse
            id="header-navbar-nav"
            className="header__nav-collapse"
          >
            <Nav className="ms-auto header__nav">
              <Nav.Link
                as={Link}
                to="/"
                onClick={() => setExpanded(false)}
                className="header__nav-link"
              >
                Trang chủ
              </Nav.Link>

              <NavDropdown
                title="Đào tạo"
                id="training-dropdown"
                className="header__nav-dropdown"
                onClick={() => setExpanded(false)}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/courses/it"
                >
                  Công nghệ thông tin
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/courses/business"
                >
                  Kinh doanh
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/courses/creative"
                >
                  Sáng tạo
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                onClick={() => scrollToSection("gioi-thieu")}
                className={`header__nav-link ${
                  activeSection === "gioi-thieu" ? "active" : ""
                }`}
              >
                Giới thiệu
              </Nav.Link>

              <Nav.Link
                onClick={() => scrollToSection("tuyen-dung")}
                className={`header__nav-link ${
                  activeSection === "tuyen-dung" ? "active" : ""
                }`}
              >
                Tuyển dụng
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
